export default () => {
  return {
    loadingStates: {},
  };
};
